import { LoadRecommendedDoctors } from 'domain/usecases/doctor/load-recommended-doctors'
import { DoctorRepository } from 'repository/interfaces/doctor-repository'

export class RemoteLoadRecommendedDoctors implements LoadRecommendedDoctors {
  private readonly doctorRepository: DoctorRepository

  constructor(doctorRepository: DoctorRepository) {
    this.doctorRepository = doctorRepository
  }

  load(
    params: LoadRecommendedDoctors.Params
  ): Promise<LoadRecommendedDoctors.Model> {
    return this.doctorRepository.loadRecommendedDoctors(params)
  }
}
